// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LCXs","field":"styles_field__1EJP3","fieldCol":"styles_fieldCol__152e9","diffCol":"styles_diffCol__3Yd04","diff":"styles_diff__2lSvK"};